var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWristWatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_64",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 510.35 218.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9fbfc;}.cls-2{fill:#036;}.cls-3{fill:#008996;}.cls-4{fill:#747475;}.cls-5{fill:#1f2f6d;}.cls-6{fill:#fff;stroke:#747475;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6,
    y: 42.77,
    width: 500,
    height: 135.47
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 256,
    cy: 110.5,
    r: 100.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 256,
    cy: 110.5,
    r: 92.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.46,107.97l-37.32-21.55c-1.4-.81-3.18-.33-3.99,1.07-.81,1.4-.33,3.18,1.07,3.99l37.32,21.55,2.92-5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M317.27,76.82c.7-.4,.94-1.3,.53-2-.4-.7-1.3-.94-2-.54l-60.54,34.95,1.46,2.53,60.54-34.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.08,115.56c-2.79-1.61-3.75-5.19-2.14-7.98,1.61-2.79,5.19-3.75,7.98-2.14,2.8,1.61,3.75,5.19,2.14,7.98-1.61,2.79-5.19,3.75-7.98,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M274.99,98.64c.35-.2,.8-.08,1,.26h0c.2,.35,.08,.8-.26,1l-80.38,46.78c-.35,.2-.8,.08-1-.26h0c-.2-.35-.09-.8,.26-1l80.38-46.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.54,113.03c-1.4-.81-1.88-2.59-1.07-3.99,.81-1.4,2.59-1.88,3.99-1.07,1.4,.81,1.88,2.59,1.07,3.99-.81,1.4-2.59,1.88-3.99,1.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M246.88,23.69c-.2,.02-.34,.2-.32,.4l.31,2.91c.02,.2,.2,.34,.4,.32,.2-.02,.34-.2,.32-.4l-.31-2.91c-.02-.2-.2-.34-.4-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M238.28,25.4c-.04-.2-.23-.32-.43-.28-.2,.04-.32,.23-.28,.43l.61,2.86c.04,.2,.23,.32,.43,.28,.2-.04,.32-.23,.28-.43l-.61-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M229.48,27.71c-.06-.19-.27-.29-.46-.23-.19,.06-.29,.27-.23,.46l.9,2.78c.06,.19,.27,.29,.46,.23,.19-.06,.29-.27,.23-.46l-.9-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M220.97,30.94c-.08-.18-.3-.26-.48-.18-.18,.08-.26,.3-.18,.48l1.19,2.67c.08,.18,.3,.26,.48,.18,.18-.08,.26-.3,.18-.48l-1.19-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.2,39.96c-.12-.16-.34-.2-.51-.08-.16,.12-.2,.34-.08,.51l1.72,2.36c.12,.16,.34,.2,.51,.08,.16-.12,.2-.34,.08-.51l-1.72-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M198.1,45.66c-.13-.15-.36-.16-.51-.03-.15,.13-.16,.36-.03,.51l1.96,2.17c.13,.15,.36,.16,.51,.03,.15-.13,.16-.36,.03-.51l-1.96-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M191.64,52.06c-.15-.13-.38-.12-.51,.03-.13,.15-.12,.38,.03,.51l2.17,1.95c.15,.13,.38,.12,.51-.03,.13-.15,.12-.38-.03-.51l-2.17-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.89,59.11c-.16-.12-.39-.08-.51,.08-.12,.16-.08,.39,.08,.51l2.36,1.72c.16,.12,.39,.08,.51-.08,.12-.16,.08-.39-.08-.51l-2.36-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.4,76l-2.67-1.19c-.18-.08-.4,0-.48,.18-.08,.18,0,.4,.18,.48l2.67,1.19c.18,.08,.4,0,.48-.18,.08-.18,0-.4-.18-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M173.21,83.98l2.78,.9c.19,.06,.39-.04,.46-.23,.06-.19-.04-.39-.23-.46l-2.78-.9c-.19-.06-.39,.04-.46,.23-.06,.19,.04,.39,.23,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.9,92.78l2.86,.61c.2,.04,.39-.08,.43-.28,.04-.2-.08-.39-.28-.43l-2.86-.61c-.2-.04-.39,.08-.43,.28-.04,.2,.08,.39,.28,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M169.51,101.77l2.91,.31c.2,.02,.38-.12,.4-.32,.02-.2-.12-.38-.32-.4l-2.91-.31c-.2-.02-.38,.12-.4,.32-.02,.2,.12,.38,.32,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.81,119.24c-.02-.2-.2-.34-.4-.32l-2.91,.31c-.2,.02-.34,.2-.32,.4,.02,.2,.2,.34,.4,.32l2.91-.31c.2-.02,.34-.2,.32-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M174.18,127.89c-.04-.2-.23-.32-.43-.28l-2.86,.61c-.2,.04-.32,.23-.28,.43,.04,.2,.23,.32,.43,.28l2.86-.61c.2-.04,.32-.23,.28-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M176.45,136.35c-.06-.19-.27-.29-.46-.23l-2.78,.9c-.19,.06-.29,.27-.23,.46,.06,.19,.27,.29,.46,.23l2.78-.9c.19-.06,.29-.27,.23-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M179.11,144.34l-2.67,1.19c-.18,.08-.26,.3-.18,.48,.08,.18,.3,.26,.48,.18l2.67-1.19c.18-.08,.26-.3,.18-.48-.08-.18-.3-.26-.48-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M187.82,159.59l-2.36,1.72c-.16,.12-.2,.34-.08,.51,.12,.16,.34,.2,.51,.08l2.36-1.72c.16-.12,.2-.34,.08-.51-.12-.16-.34-.2-.51-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M193.33,166.44l-2.17,1.95c-.15,.13-.16,.36-.03,.51,.13,.15,.36,.16,.51,.03l2.17-1.95c.15-.13,.16-.36,.03-.51-.13-.15-.36-.16-.51-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.52,172.69l-1.96,2.17c-.13,.15-.12,.38,.03,.51,.15,.13,.38,.12,.51-.03l1.96-2.17c.13-.15,.12-.38-.03-.51-.15-.13-.38-.12-.51,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.33,178.25l-1.72,2.36c-.12,.16-.08,.39,.08,.51,.16,.12,.39,.08,.51-.08l1.72-2.36c.12-.16,.08-.39-.08-.51-.16-.12-.39-.08-.51,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M221.97,186.91c-.18-.08-.4,0-.48,.18l-1.19,2.67c-.08,.18,0,.4,.18,.48,.18,.08,.4,0,.48-.18l1.19-2.67c.08-.18,0-.4-.18-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M230.15,190.05c-.19-.06-.39,.04-.46,.23l-.9,2.78c-.06,.19,.04,.39,.23,.46,.19,.06,.39-.04,.46-.23l.9-2.78c.06-.19-.04-.39-.23-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M238.61,192.32c-.2-.04-.39,.08-.43,.28l-.61,2.86c-.04,.2,.08,.39,.28,.43,.2,.04,.39-.08,.43-.28l.61-2.86c.04-.2-.08-.39-.28-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M247.25,193.69c-.2-.02-.38,.12-.4,.32l-.31,2.9c-.02,.2,.12,.38,.32,.4,.2,.02,.38-.12,.4-.32l.31-2.9c.02-.2-.12-.38-.32-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.74,193.69c-.2,.02-.34,.2-.32,.4l.3,2.9c.02,.2,.2,.34,.4,.32,.2-.02,.34-.2,.32-.4l-.3-2.9c-.02-.2-.2-.34-.4-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M273.82,192.6c-.04-.2-.23-.32-.43-.28-.2,.04-.32,.23-.28,.43l.61,2.86c.04,.2,.23,.32,.43,.28,.2-.04,.32-.23,.28-.43l-.61-2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.3,190.29c-.06-.19-.27-.29-.46-.23-.19,.06-.29,.27-.23,.46l.9,2.78c.06,.19,.27,.29,.46,.23,.19-.06,.29-.27,.23-.46l-.9-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.5,187.1c-.08-.18-.29-.26-.48-.18-.18,.08-.26,.29-.18,.48l1.19,2.67c.08,.18,.29,.26,.48,.18,.18-.08,.26-.29,.18-.48l-1.19-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M305.67,178.26c-.12-.16-.34-.2-.5-.08-.16,.12-.2,.34-.08,.5l1.72,2.36c.12,.16,.34,.2,.51,.08,.16-.12,.2-.34,.08-.51l-1.72-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M312.48,172.69c-.13-.15-.36-.16-.51-.03-.15,.13-.16,.36-.03,.51l1.95,2.17c.13,.15,.36,.16,.51,.03,.15-.13,.16-.36,.03-.51l-1.95-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M318.67,166.45c-.15-.13-.38-.12-.51,.03-.13,.15-.12,.38,.03,.51l2.17,1.96c.15,.13,.38,.12,.51-.03,.13-.15,.12-.38-.03-.51l-2.17-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M324.18,159.59c-.16-.12-.39-.08-.5,.08-.12,.16-.08,.39,.08,.51l2.36,1.72c.16,.12,.39,.08,.51-.08,.12-.16,.08-.39-.08-.5l-2.36-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M335.56,145.53l-2.67-1.19c-.18-.08-.4,0-.48,.18-.08,.18,0,.4,.18,.48l2.67,1.19c.18,.08,.4,0,.48-.18,.08-.18,0-.4-.18-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M338.79,137.02l-2.78-.9c-.19-.06-.39,.04-.46,.23-.06,.19,.04,.39,.23,.46l2.78,.9c.19,.06,.39-.04,.46-.23,.06-.19-.04-.39-.23-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M341.1,128.23l-2.86-.61c-.2-.04-.39,.08-.43,.28-.04,.2,.08,.39,.28,.43l2.86,.61c.2,.04,.39-.08,.43-.28,.04-.2-.08-.39-.28-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M342.49,119.23l-2.9-.31c-.2-.02-.38,.12-.4,.32-.02,.2,.12,.38,.32,.4l2.9,.31c.2,.02,.38-.12,.4-.32,.02-.2-.12-.38-.32-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M339.19,101.76c.02,.2,.2,.34,.4,.32l2.9-.3c.2-.02,.34-.2,.32-.4-.02-.2-.2-.34-.4-.32l-2.9,.3c-.2,.02-.34,.2-.32,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M337.82,93.11c.04,.2,.23,.32,.43,.28l2.86-.61c.2-.04,.32-.23,.28-.43-.04-.2-.23-.32-.43-.28l-2.86,.6c-.2,.04-.32,.23-.28,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M335.55,84.65c.06,.19,.27,.29,.46,.23l2.78-.9c.19-.06,.29-.27,.23-.46-.06-.19-.27-.29-.46-.23l-2.78,.9c-.19,.06-.29,.27-.23,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M332.89,76.66l2.67-1.18c.18-.08,.26-.29,.18-.48-.08-.18-.29-.26-.48-.18l-2.67,1.18c-.18,.08-.26,.29-.18,.48,.08,.18,.29,.26,.48,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M326.12,59.12l-2.36,1.71c-.16,.12-.2,.34-.08,.51s.34,.2,.51,.08l2.36-1.71c.16-.12,.2-.34,.08-.51-.12-.16-.34-.2-.5-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M320.36,52.07l-2.17,1.95c-.15,.13-.16,.36-.03,.51,.13,.15,.36,.16,.51,.03l2.17-1.95c.15-.13,.16-.36,.03-.51-.13-.15-.36-.16-.51-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M313.9,45.66l-1.96,2.17c-.13,.15-.12,.38,.03,.51,.15,.13,.38,.12,.51-.03l1.96-2.17c.13-.15,.12-.38-.03-.51-.15-.13-.38-.12-.51,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.81,39.96l-1.72,2.36c-.12,.16-.08,.39,.08,.51,.16,.12,.39,.08,.51-.08l1.72-2.36c.12-.16,.08-.39-.08-.51-.16-.12-.39-.08-.51,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M291.51,30.76c-.18-.08-.4,0-.48,.18l-1.19,2.67c-.08,.18,0,.4,.18,.48,.18,.08,.4,0,.48-.18l1.19-2.67c.08-.18,0-.4-.18-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M282.98,27.48c-.19-.06-.39,.04-.46,.23l-.91,2.78c-.06,.19,.04,.39,.23,.46,.19,.06,.39-.04,.46-.23l.91-2.78c.06-.19-.04-.39-.23-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.15,25.12c-.2-.04-.39,.08-.43,.28l-.61,2.86c-.04,.2,.08,.39,.28,.43,.2,.04,.39-.08,.43-.28l.61-2.86c.04-.2-.08-.39-.28-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265.13,23.69c-.2-.02-.38,.12-.4,.32l-.31,2.91c-.02,.2,.12,.38,.32,.4,.2,.02,.38-.12,.4-.32l.31-2.91c.02-.2-.12-.38-.32-.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340.19,112.72c-1.22-.71-1.65-2.27-.94-3.5,.71-1.22,2.27-1.64,3.5-.94,1.23,.71,1.64,2.27,.94,3.5-.71,1.22-2.27,1.65-3.5,.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.02,70.33c-1.41,0-2.56-1.15-2.56-2.56,0-1.41,1.15-2.56,2.56-2.56,1.42,0,2.56,1.15,2.56,2.56,0,1.41-1.15,2.56-2.56,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.01,38.7c-1.22,.71-2.79,.29-3.5-.94-.71-1.22-.29-2.79,.94-3.5,1.23-.71,2.79-.29,3.5,.93,.71,1.22,.29,2.79-.94,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.22,26.32c-.71,1.22-2.27,1.64-3.5,.93-1.22-.71-1.64-2.28-.94-3.5,.71-1.23,2.27-1.65,3.5-.94,1.22,.71,1.65,2.28,.94,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.83,36.49c0,1.41-1.15,2.56-2.56,2.56s-2.56-1.15-2.56-2.56c0-1.42,1.15-2.56,2.56-2.57,1.41,0,2.56,1.15,2.56,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.2,66.49c.71,1.22,.29,2.79-.94,3.5-1.22,.71-2.79,.28-3.5-.94-.71-1.23-.29-2.79,.93-3.5,1.22-.7,2.79-.29,3.5,.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.82,108.28c1.22,.71,1.64,2.27,.93,3.5-.71,1.22-2.28,1.64-3.5,.94-1.23-.71-1.65-2.27-.94-3.5,.71-1.22,2.27-1.64,3.5-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.99,150.67c1.41,0,2.56,1.15,2.56,2.57s-1.15,2.56-2.56,2.56c-1.42,0-2.56-1.15-2.56-2.56,0-1.42,1.15-2.56,2.57-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.99,182.3c1.23-.71,2.79-.29,3.5,.94,.71,1.22,.28,2.79-.94,3.5-1.23,.71-2.79,.29-3.5-.94-.71-1.23-.29-2.79,.94-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.78,194.68c.71-1.23,2.27-1.64,3.5-.94,1.22,.71,1.64,2.28,.93,3.5-.71,1.23-2.27,1.65-3.5,.94-1.22-.71-1.64-2.27-.94-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.17,184.51c0-1.41,1.15-2.56,2.56-2.56,1.41,0,2.56,1.15,2.56,2.56,0,1.42-1.15,2.56-2.56,2.56s-2.56-1.14-2.56-2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.8,154.51c-.71-1.22-.28-2.79,.94-3.5,1.22-.7,2.79-.28,3.5,.94,.71,1.23,.29,2.79-.94,3.5-1.22,.71-2.79,.29-3.5-.94Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWristWatch);
export default __webpack_public_path__ + "static/media/wrist-watch.c6b7dc375754ea357b7356577f09a27d.svg";
export { ForwardRef as ReactComponent };